import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const installBundle = gql`
  mutation InstallBundleMutation($input: InstallBundle!) {
    installBundle(input: $input) {
      ...AnyDuplicationResult
    }
  }

  ${Fragments.bundle.AnyDuplicationResult}
`;
